import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { faAt, faPhone } from "@fortawesome/free-solid-svg-icons";
import SEO, { pageSEO } from "../components/seo.component";
import aboutHero from "../assets/images/asset-generation-edfbdf3b-7b0e-46c1-90b0-80560a917228-1-watermarked.jpg";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import { useUserParams } from "../hooks/useUserParams";

export default function About() {
  const seoConfig = pageSEO.about();
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentAbout,
    getCurrentHeadshot,
  } = useUserParams();

  return (
    <>
      <SEO {...seoConfig} />

      <section className="relative overflow-hidden bg-harbour-sky/20 pt-36 pb-24">
        <div className="relative mx-auto max-w-[1400px] px-6 lg:px-16">
          <div className="grid items-start gap-16 lg:grid-cols-12 mt-20">

            {/* Profile Image */}
            <motion.div
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative lg:col-span-5"
            >
              <div className="absolute -left-10 -top-6 h-full w-full border-2 border-harbour-accent/50 rounded-[40px]" />

              <div className="relative overflow-hidden rounded-[40px] shadow-2xl">
                <img
                  src={getCurrentHeadshot()}
                  alt={getCurrentAgentName()}
                  className="h-[650px] w-full object-cover"
                />
              </div>

              <div className="absolute bottom-8 left-8 right-8 rounded-3xl bg-white/90 p-6 shadow-xl backdrop-blur">
                <p className="uppercase tracking-[0.4em] text-harbour-blue">
                  {getCurrentAgentTitle()}
                </p>

                <h3 className="mt-3 font-serif text-3xl text-harbour-navy">
                  {getCurrentAgentName()}
                </h3>

                <p className="mt-2 text-harbour-muted">
                  {getCurrentBrokerage()}
                </p>
              </div>
            </motion.div>

            {/* Content */}
            <motion.div
              initial={{ opacity: 0, x: 80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="lg:col-span-7"
            >
              <div className="flex items-center gap-4">
                <div className="h-px w-16 bg-harbour-accent" />

                <span className="uppercase tracking-[0.5em] text-harbour-blue">
                  About Me
                </span>
              </div>

              <h1 className="mt-8 font-serif text-5xl leading-tight text-harbour-navy lg:text-6xl">
                Guiding You
                <br />
                Through Every
                <br />
                Move.
              </h1>

              <p className="mt-8 max-w-2xl whitespace-pre-line text-lg leading-8 text-harbour-muted">
                {getCurrentAbout()}
              </p>

              <div className="mt-10 grid gap-5 sm:grid-cols-2">
                <div className="rounded-3xl border border-harbour-border bg-white p-6">
                  <FontAwesomeIcon
                    icon={faWhatsapp}
                    className="text-2xl text-harbour-accent"
                  />
                  <p className="mt-4 text-sm uppercase tracking-widest text-harbour-muted">
                    Phone
                  </p>
                  <p className="mt-2 font-medium text-harbour-navy">
                    {getCurrentAgentNumber()}
                  </p>
                </div>

                <div className="rounded-3xl border border-harbour-border bg-white p-6">
                  <FontAwesomeIcon
                    icon={faAt}
                    className="text-2xl text-harbour-accent"
                  />
                  <p className="mt-4 text-sm uppercase tracking-widest text-harbour-muted">
                    Email
                  </p>
                  <p className="mt-2 break-all font-medium text-harbour-navy">
                    {getCurrentAgentEmail()}
                  </p>
                </div>
              </div>

              <div className="mt-10">
                <Link to={"/contact"} className="btn-harbour">
                  Connect With Me
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>

  );
}
